import PropTypes from 'prop-types';

export const alignItems = PropTypes.oneOf([
    'flex-start',
    'center',
    'flex-end',
    'stretch',
    'baseline'
]);

export const alignContent = PropTypes.oneOf([
    'stretch',
    'center',
    'flex-start',
    'flex-end',
    'space-between',
    'space-around'
]);

export const direction = PropTypes.oneOf([
    'row',
    'row-reverse',
    'column',
    'column-reverse'
]);

export const justify = PropTypes.oneOf([
    'flex-start',
    'center',
    'flex-end',
    'space-between',
    'space-around',
    'space-evenly'
]);

export const wrap = PropTypes.oneOf([
    'nowrap',
    'wrap',
    'wrap-reverse'
]);

export const item = PropTypes.bool;
export const container = PropTypes.bool;
export const itemClass = PropTypes.string;
export const containerClass = PropTypes.string;
export const children = PropTypes.node;

export const spacing = PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7 ,8 , 9, 10])

export const deviceTypeArr = PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, false, true]);




